module.exports = __webpack_public_path__ + "img/wizard-icon-describe.be3905c6.png";